import React, { useState, useEffect } from 'react'
import search from "../images/search.svg";
import axis from "../images/axisBank.svg";
import icci from "../images/icci.svg";
import hdfc from "../images/hdfcbank.svg";
import kotak from "../images/kotak.svg";
import pnb from "../images/pnb.svg";
import sbi from "../images/sbi.svg";
import shield from "../images/Shield.png";
import homebank from "../images/DefaultBank.svg";
import { useNavigate } from 'react-router-dom';
import bank from "../images/DefaultBank.svg";
import Footer from "./Footer";
import { useMyContext } from '../../AppContext';
import { Loader } from '../helper/Loader';
import mixpanel from 'mixpanel-browser';
import { getFpiList,getFpiListSixBanks ,getBankSearchApi} from '../Apiservices';
import dropdown from "../images/dropdown.svg";
import dropup from "../images/dropup.svg";
import { ImagesURL as ImagesURLFUNC } from '../helper/Commonfunctions';
import { toast} from 'react-toastify';
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });


 function SelectBank() {
    const ImagesURL=ImagesURLFUNC();
    const Bankinfo1=[
        {
            fip_name:"Axis Bank",
            url:axis
        },
        {
            fip_name:"State Bank Of India",
            url:sbi
        },
        {
            fip_name:"HDFC Bank",
            url:hdfc
        },
        {
            fip_name:"Kotak Mahindra Bank",
            url:kotak
        },
        {
            fip_name:"Punjab National Bank",
            url:pnb
        },
        {
            fip_name:"ICICI Bank",
            url:icci
        },
      

    ]

    const OtherBanksinfo2=[
        {
            name:"ADCB",
            url:axis
        },
        {
            name:"AGs Bank",
            url:sbi
        },
        {
            name:"ANZ Bank",
            url:hdfc
        },
        {
            name:"AU Small Finance Bank",
            url:kotak
        },
        {
            name:"Allahabad Bank",
            url:pnb
        },
        {
            name:"American Express Bank",
            url:icci
        },
      

    ]
    const delay = 800; 
    let timer = null;
const [OtherBanksinfo,SetOtherBankInfo]=useState(OtherBanksinfo2);
const [Pendingrequest,SetPendingRequest]=useState(false);
const [Bankinfo,SetBankinfo]=useState(Bankinfo1);
const [FirstSixDropdownBankinfo,SetFirstSixDropDown]=useState([]);
const { Storage,SetStorage } = useMyContext();
const [Text,SetText]=useState('');
useEffect(() => {
  const previousPage = document.referrer;

  window.history.pushState(null, null, window.location.href);
  window.onpopstate = function () {
    window.history.pushState(null, null, window.location.href);
  }
  return () => {
    window.onpopstate = null;
  };
}, []);
useEffect(() => {

//   window.addEventListener("beforeunload", function (event) {
  
//     window.opener = null;
// window.open('', '_self');
// window.close();
// });

   if(Storage.Socketconnnection==null)
   {

       localStorage.clear();
       window.open(process.env.REACT_APP_CLOSING_URL, "_self");

   }
   else{
     handleGetOtherBankInfo();
     mixpanel.track("Viewed_BS_Select_Bank", {
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
    }
}, [])

const handleGetOtherBankInfo=()=>{
    SetPendingRequest(true);
        getFpiList().then((response)=>{
              if(response?.status==200)
              {
                SetOtherBankInfo(response?.data);
                let banks=[];
                for(let i=0;i<(response.data.length>6?6:response.data.length);i++)
                {
                    // console.log(response.data[i]);
                    banks.push(response.data[i]);
                }
                SetFirstSixDropDown(banks);
                handleSingleSixBankInfo();
               
              }
        }).catch((error)=>{
            SetPendingRequest(false);
            if(error?.response?.status==401)
            {
            toast.error("Your session is expired. Please try again");
        
            setTimeout(()=>{
              localStorage.clear();
              window.open(process.env.REACT_APP_CLOSING_URL, "_self");
        
            },1000)
          }else{
            Storage.internalservererror=true;
            SetStorage(Storage);
            navigate('/finalresult');
          }
        })
}

const handleSingleSixBankInfo=()=>{
    SetPendingRequest(true);
  getFpiListSixBanks().then((response)=>{
if(response?.status==200)
{
    SetBankinfo(response?.data);
    SetPendingRequest(false);
}
  }).catch((error)=>{
SetPendingRequest(false);
if(error?.response?.status==401)
{
toast.error("Your session is expired. Please try again");

setTimeout(()=>{
  localStorage.clear();
  window.open(process.env.REACT_APP_CLOSING_URL, "_self");

},1000)
}else{
  Storage.internalservererror=true;
  SetStorage(Storage);
navigate('/finalresult');
}

  })

}
const [inputSearchBank,SetinputSearchBank]=useState([]);
const [inptext,Setinptext]=useState('');

useEffect(() => {
  // console.log('1');
 if(inptext=='')
 {
    SetinputSearchBank([]);
    Setactive(0);
 }
}, [inptext],[inputSearchBank])
const removespaces=(text)=>{
  let s="";
  for(let i=0;i<text.length;i++)
  {
    if(text[i]!=' ')
       s+=text[i];
  }
  return s;
}
const handleSearchinput=(e)=>{
    const text=e.target.value;
    let m=removespaces(text);
    Setinptext(m);
    if(m==="")
    {
        SetinputSearchBank([]);
        Setactive(0);
        return ;
    }
    else{
       
        clearTimeout(timer);
        timer = setTimeout(() => {
          performSearch(m);
        }, delay);

   
}

}

const performSearch=(text)=>{
    getBankSearchApi(text).then((response)=>{
        if(response?.status==200)
        {
        
              SetinputSearchBank(response?.data);
          //  console.log(response.data[0]);
        }
   }).catch((error)=>{
    if(error?.response?.status==401)
    {
    toast.error("Your session is expired. Please try again");

    setTimeout(()=>{
      localStorage.clear();
      window.open(process.env.REACT_APP_CLOSING_URL, "_self");

    },1000)
  }else{
    Storage.internalservererror=true;
    SetStorage(Storage);
    navigate('/finalresult');
  }

   })

}
const navigate=useNavigate();
const handleclickBank=(val)=>{

    mixpanel.track("Interacted_BS_Select_Bank", {
        "Clicked on": val?.fip_name,
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
  // console.log(val.fip_name);
    Storage.selectedbank=val;
    // console.log(Storage);
    SetStorage(Storage);
   navigate('/link_account');
}
const [active,Setactive]=useState(0);
const handleClickDropdown=()=>{
     Setactive(1-active);
}
  return (
    <div className='selectbank'>
      {Pendingrequest &&  <Loader/> }
 <div className='input'>
<input type='text' spellcheck="false" placeholder='Search all banks ' onChange={handleSearchinput} >
</input>
</div>
<div className='allbanks'>
<div className='Banks'>
{inputSearchBank.length==0 &&
Bankinfo.map((val,key)=>{
    return (
        <div className='singlebank' onClick={(e)=>{e.preventDefault();handleclickBank(val)}} >
        <img src={ImagesURL.get(val?.fip_id)!=null?ImagesURL.get(val?.fip_id):(ImagesURL.get(val?.fip_name)!=null?ImagesURL.get(val?.fip_name):(val?.entity_icon_uri?val?.entity_icon_uri:homebank))}></img>
        <p>{val?.fip_name}</p>
        </div>
    )
})}


</div>
<div className='othersbank'>
{inputSearchBank.length==0?<h1 onClick={handleClickDropdown} className={active?"active":""}>VIEW MORE BANKS <img src={active==0?dropdown:dropup} ></img></h1>:<></>}
{(active==1 && inputSearchBank.length==0) && OtherBanksinfo.map((val,key)=>{
    return(
        <div className='banks' onClick={(e)=>{e.preventDefault();handleclickBank(val)}} >
            <div className='mybank'>
            <img src={ImagesURL.get(val?.fip_id)!=null?ImagesURL.get(val?.fip_id):(ImagesURL.get(val?.fip_name)!=null?ImagesURL.get(val?.fip_name):(val?.entity_icon_uri?val?.entity_icon_uri:homebank))}></img>
          <span>{val?.fip_name}</span>
            </div>
          <hr></hr>
        </div>
    )
})}
{(active==0 && inputSearchBank.length==0) && FirstSixDropdownBankinfo.map((val,key)=>{
    return(
        <div className='banks' onClick={(e)=>{e.preventDefault();handleclickBank(val)}} >
         <div className='mybank'>
         <img src={ImagesURL.get(val?.fip_id)!=null?ImagesURL.get(val?.fip_id):(ImagesURL.get(val?.fip_name)!=null?ImagesURL.get(val?.fip_name):(val?.entity_icon_uri?val?.entity_icon_uri:homebank))}></img>
          <span>{val?.fip_name}</span>
            </div>
          <hr></hr>
        </div>
    )
})}

  {inputSearchBank?.map((val,key)=>{
    return(
        <div className='banks' onClick={(e)=>{e.preventDefault();handleclickBank(val)}} >
          <div className='mybank'>
          <img src={ImagesURL.get(val?.fip_id)!=null?ImagesURL.get(val?.fip_id):(ImagesURL.get(val?.fip_name)!=null?ImagesURL.get(val?.fip_name):(val?.entity_icon_uri?val?.entity_icon_uri:homebank))}></img>
          <span>{val?.fip_name}</span>
            </div>
          <hr></hr>
        </div>
    )
})}

</div>

 </div>
 <div className='footer2'>
<Footer/>
 </div>

{/* <div className='footer2'>

 <div className='footer'>
    <img src={shield}></img>
    <p>Your data is 100 % safe and secure</p>
</div>

</div> */}

</div>
  )
}
export default React.memo(SelectBank);